import { render, staticRenderFns } from "./CreateWalletModal.vue?vue&type=template&id=05276d29&scoped=true&"
import script from "./CreateWalletModal.vue?vue&type=script&lang=js&"
export * from "./CreateWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletModal.vue?vue&type=style&index=0&id=05276d29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05276d29",
  null
  
)

export default component.exports